import { cn } from '@dreamstack/util/src/cn'
import { Disclosure } from '@headlessui/react'
import type { FunctionComponent } from 'react'
import {
  expandableTitle,
  StyledChevronDown,
  StyledChevronUp,
  StyledDiv,
  StyledHeadingH2,
} from './AccordionStyledComponents'

export const ArrowAccordionDisclosureButton: FunctionComponent<
  React.PropsWithChildren<{
    open: boolean
    title: string
    titleWhenExpanded?: string
    clickHandler?: (index: number, action: boolean) => void
    index?: number
    className?: string
    useAqua?: boolean
    smallSize?: boolean
  }>
> = ({
  open,
  title,
  titleWhenExpanded,
  clickHandler,
  index,
  useAqua,
  smallSize,
  className,
}) => {
  return (
    <>
      <Disclosure.Button
        className={cn(
          'text-left w-full text-accentroGray-full focus:outline-none',
          className
        )}
      >
        <StyledDiv useAqua={useAqua}>
          <button
            type="button"
            onClick={() =>
              clickHandler && index ? clickHandler(index, open) : null
            }
            className="contents"
          >
            <StyledHeadingH2 className="mr-px-12" smallSize={smallSize}>
              {expandableTitle(title, titleWhenExpanded, open)}
            </StyledHeadingH2>
            {open ? (
              <StyledChevronUp $smallSize={smallSize} />
            ) : (
              <StyledChevronDown $smallSize={smallSize} />
            )}
          </button>
        </StyledDiv>
      </Disclosure.Button>
    </>
  )
}
